import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AudioDeviceService {
  private selectedDeviceId = '';

  async getMicrophones(): Promise<MediaDeviceInfo[]> {
    if (!navigator.mediaDevices?.enumerateDevices) {
      throw new Error('MediaDevices API not supported');
    }

    const uniqueDevices = new Map<string, MediaDeviceInfo>();
    const devices = await navigator.mediaDevices.enumerateDevices();
    devices
      .filter(device =>
        device.kind === 'audioinput'
        && device.deviceId !== 'communications'
        && device.label.trim() !== ''
      )
      .forEach(device => uniqueDevices.set(device.groupId || device.deviceId, device));

    return Array.from(uniqueDevices.values());
  }

  setDeviceId(deviceId: string): void {
    this.selectedDeviceId = deviceId || '';
  }

  getDeviceId(): string {
    return this.selectedDeviceId;
  }
}
